import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, LineClamp, ShowVerticalScrollbar } from '../../../global/commonStyle';

const MessageDiv = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
`;

const Header = styled.div`
  ${FlexBetween}
  gap: var(--space-12);
  padding: var(--space-8) var(--space-24);
  border-bottom: 0.5px solid var(--border-primary);
  position: sticky;
  top: 0;
`;

const LeftHeader = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
  p {
    margin: var(--space-0);
    ${Typography.body_lg_medium}
    color: var(--text-primary);
  }
  ${mobile_xl(css`
    p {
      ${LineClamp(1)}
      word-break: break-all;
    }
  `)}
`;

const SearchHeader = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
  border-bottom: 0.5px solid var(--border-primary);
  position: sticky;
  top: 0;
  gap: var(--space-0);
  position: relative;
  z-index: var(--z-index-999);
  background-color: var(--background-secondary);
  p {
    margin: var(--space-0);
    ${Typography.body_lg}
    color: var(--text-primary);
  }
  ${mobile_xl(css`
    align-items: flex-start;
  `)}
`;

const Text = styled.div`
  padding-top: var(--space-6);
  color: var(--text-primary);
  ${Typography.body_lg}
  ${mobile_xl(css`
    text-align: center;
  `)}
`;

const Selects = styled.div<{ tagsSelected?: boolean }>`
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: var(--space-12);
  padding: var(--space-7) var(--space-24);
  ${mobile_xl(css<{ tagsSelected?: boolean }>`
    padding: var(--space-4) var(--space-20) var(--space-8);
  `)}
`;

const Icons = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
  &.normal-group {
    gap: var(--space-24);
  }
`;

const AssignContent = styled.div`
  width: 100%;
  max-width: 238px;
  position: relative;
  ${mobile_xl(css`
    max-width: unset;
    width: 75px;
  `)}
`;

const AssignGroup = styled.div`
  width: 100%;
  max-width: 140px;
  margin-left: var(--space-16);

  ul {
    display: flex;
    flex-wrap: wrap;
    list-style-type: none;
    padding: var(--space-0);
    margin: var(--space-0);
  }

  li {
    margin-right: -8px;
    position: relative;
    ${mobile_xl(css`
      margin-right: -9px;
    `)}
  }
  .plus-icon {
    width: 24px;
    height: 24px;
    border-radius: var(--border-radius-full);
    align-items: center;
    justify-content: center;
    color: white;
    display: flex;
    background: var(--background-muted);
    ${Typography.body_xs_semibold}
    border: 1px solid var(--background-secondary);
    position: relative;
    top: 0;
    z-index: var(--z-index-base);
    ${mobile_xl(css`
      width: 20px;
      height: 20px;
    `)}
  }
`;
const Plus = styled.div`
  ${Typography.body_xs_semibold}
  color: var(--text-primary);
  position: absolute;
  top: 6px;
  ${mobile_xl(css`
    top: 4px;
  `)}
`;

const ItemDiv = styled.div`
  max-height: 150px;
  margin-right: var(--space-4);
  ${ShowVerticalScrollbar}
`;

const DropDiv = styled.div`
  .active-state {
    border-radius: var(--border-radius-8);
    background: var(--neutral-secondary);
  }
`;
export {
  MessageDiv,
  Header,
  Selects,
  Text,
  SearchHeader,
  LeftHeader,
  Icons,
  AssignContent,
  AssignGroup,
  Plus,
  ItemDiv,
  DropDiv
};
